import { Alert } from 'react-bootstrap';

type AiFormWarningAlertProps = {
  message: string | null;
  onClose: () => void;
};

/** Danger alert under AI forms for any non-200 API response message. */
const AiFormWarningAlert = ({ message, onClose }: AiFormWarningAlertProps) => {
  if (!message) return null;

  return (
    <Alert
      variant="danger"
      className="mb-3 fs--1"
      dismissible
      onClose={onClose}
    >
      {message}
    </Alert>
  );
};

export default AiFormWarningAlert;
